import { Drawer } from "antd";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function DashboardLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
      }}
    >
      {/* Desktop Sidebar */}
      <div className="hidden md:block">
        <div className="fixed left-0 top-0 w-[280px] h-screen bg-white border-r">
          <Sidebar />
        </div>
      </div>

      

      {/* Mobile Sidebar */}
      <Drawer
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        placement="left"
        width={280}
      >
        <Sidebar />
      </Drawer>

      {/* Main Area */}
      <div className="md:ml-[280px] flex-1 min-h-screen"
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Topbar
          openSidebar={() =>
            setMobileOpen(true)
          }
        />

        <div
          style={{
            flex: 1,
            padding:
              window.innerWidth <= 768
                ? 12
                : 24,
            background: "#f7f7f7",
          }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
}